export const DEFAULT_TEAMS = [
  {
    id: 101,
    name: "Neon Wolves",
    game: "Counter-Strike 2",
    description: "Агрессивная команда с упором на быстрые выходы и сильную стрельбу.",
    captainName: "Артём Волков",
    captainEmail: "wolf@vskturn.ru",
    createdAt: "01.06.2026, 12:00:00",
    members: [
      { name: "Артём Волков", email: "wolf@vskturn.ru", role: "Капитан", status: "Участник" },
      { name: "Илья Морозов", email: "moroz@vskturn.ru", role: "Игрок", status: "Участник" },
      { name: "Данил Соколов", email: "sokol@vskturn.ru", role: "Игрок", status: "Участник" },
    ],
    invitedEmails: [],
  },
  {
    id: 102,
    name: "Ancient Five",
    game: "Dota 2",
    description: "Состав с сильной макроигрой и дисциплинированным контролем карты.",
    captainName: "Кирилл Орлов",
    captainEmail: "ancient@vskturn.ru",
    createdAt: "02.06.2026, 15:30:00",
    members: [
      { name: "Кирилл Орлов", email: "ancient@vskturn.ru", role: "Капитан", status: "Участник" },
      { name: "Павел Лебедев", email: "lebedev@vskturn.ru", role: "Игрок", status: "Участник" },
      { name: "Марк Егоров", email: "egorov@vskturn.ru", role: "Игрок", status: "Участник" },
    ],
    invitedEmails: [],
  },
  {
    id: 103,
    name: "Spike Rush",
    game: "Valorant",
    description: "Команда любит быстрые раунды, размены и активную игру через дуэлянтов.",
    captainName: "Никита Смирнов",
    captainEmail: "spike@vskturn.ru",
    createdAt: "03.06.2026, 18:10:00",
    members: [
      { name: "Никита Смирнов", email: "spike@vskturn.ru", role: "Капитан", status: "Участник" },
      { name: "Алина Федорова", email: "alina@vskturn.ru", role: "Игрок", status: "Участник" },
      { name: "Роман Новиков", email: "novikov@vskturn.ru", role: "Игрок", status: "Участник" },
    ],
    invitedEmails: [],
  },
  {
    id: 104,
    name: "Rift Breakers",
    game: "League of Legends",
    description: "Команда для турниров по LoL: сильные линии, контроль объектов и командные драки.",
    captainName: "Егор Ким",
    captainEmail: "rift@vskturn.ru",
    createdAt: "04.06.2026, 19:45:00",
    members: [
      { name: "Егор Ким", email: "rift@vskturn.ru", role: "Капитан", status: "Участник" },
      { name: "Максим Кузнецов", email: "kuznetsov@vskturn.ru", role: "Игрок", status: "Участник" },
      { name: "Сергей Ли", email: "lee@vskturn.ru", role: "Игрок", status: "Участник" },
    ],
    invitedEmails: [],
  },
  {
    id: 105,
    name: "Turbo Boost",
    game: "Rocket League",
    description: "Быстрый состав для 3x3 матчей с акцентом на воздушные атаки.",
    captainName: "Олег Захаров",
    captainEmail: "turbo@vskturn.ru",
    createdAt: "05.06.2026, 20:20:00",
    members: [
      { name: "Олег Захаров", email: "turbo@vskturn.ru", role: "Капитан", status: "Участник" },
      { name: "Тимур Сафин", email: "safin@vskturn.ru", role: "Игрок", status: "Участник" },
      { name: "Денис Белый", email: "bely@vskturn.ru", role: "Игрок", status: "Участник" },
    ],
    invitedEmails: [],
  },
];
